import React from "react";

const variantClasses = {
  primary: "bg-gradient-primary text-content-inverse hover:shadow-glow-cyan transition-all font-medium",
  secondary: "bg-transparent border border-border text-content-primary hover:bg-theme-hover hover:border-border-hover transition-all",
  danger: "bg-risk-critical text-white hover:brightness-110 transition-all",
  success: "bg-status-success text-white hover:brightness-110 transition-all",
  ghost: "bg-transparent text-content-secondary hover:text-content-primary hover:bg-theme-hover transition-all",
};

const sizeClasses = {
  sm: "px-3 py-1.5 text-sm rounded-md",
  md: "px-4 py-2 text-sm rounded-lg",
  lg: "px-6 py-3 text-base rounded-lg",
};

export const Button = ({
  children,
  onClick,
  className = "",
  variant = "ghost",
  size = "sm",
  disabled = false,
  type = "button",
  ...props
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`
        inline-flex items-center justify-center font-medium
        focus:outline-none focus:ring-2 focus:ring-accent-cyan/50 focus:ring-offset-2 focus:ring-offset-theme-primary
        disabled:opacity-50 disabled:cursor-not-allowed
        ${variantClasses[variant] || variantClasses.ghost}
        ${sizeClasses[size] || sizeClasses.sm}
        ${className}
      `}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
